var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('full-width-bg-generic',{attrs:{"displayIcon":"","heroText":"Meet our team of experts","backgroundType":2}}),_c('page-nav'),_c('about-ccic-content'),_c('about-program-content'),_c('about-faculty-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }